import { useTranslation } from 'react-i18next';
import type { ElementNav } from '@/navigation/navigation';
import { Toolbar } from '@/layout/Toolbar';

export function PantallaPendent({ element }: { element: ElementNav }) {
  const { t } = useTranslation(['comu', element.ns]);
  return (
    <div data-screen={element.pantalla} className="pantalla">
      <Toolbar titol={t(`titols.${element.clau}`, { ns: element.ns })} />
      <div className="content">
        <div className="panel">
          <div className="panel__body empty">
            {t('estatPagina.pendentText', { ns: 'comu', id: element.pantalla })}
          </div>
        </div>
      </div>
    </div>
  );
}
